<template>
  <div id="pagemoduleupdate-dialog" class="custom-modal">
    <div class="modal-body">

        <el-col :span="24">
          <el-button-group class="w-100 d-flex">
            <el-button :type="type == 0 ? 'primary' : 'default'" class="flex-grow-1" @click="type = 0" size="mini" round>{{$t('components.eventinfo.pageModuleUpdate.defaultEn')}}</el-button>
            <el-button :type="type == 1 ? 'primary' : 'default'" class="flex-grow-1" @click="type = 1" size="mini" round>{{$t('components.eventinfo.pageModuleUpdate.tr')}}</el-button>
          </el-button-group>
        </el-col>

        <transition name="el-fade-in" mode="out-in">
          <el-col :span="24" class="english" v-if="type == 0" key="english">
            <el-row :gutter="10">
              <el-col :span="24" class="mt-3">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>Title</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>Defines the name of the module.</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-input v-model="form.title" :class="$inputError('settings.MetaTitle', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage('settings.MetaTitle', validationErrors) }}</span>
                </div>
              </el-col>
              <el-col :span="24" class="mt-3" v-if="form.isCustom == true">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>Url</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>Defines the url that the module will access.</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-input v-model="form.url" :class="$inputError('url', validationErrors)">
                    <template slot="prepend">
                      https://
                    </template>
                  </el-input>
                  <span class="error">{{ $errorMessage('url', validationErrors) }}</span>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24" class="turkish" v-else key="turkish">
            <el-row :gutter="10">
              <el-col :span="24" class="mt-3">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>Başlık</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>Modülün adını tanımlar.</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-input v-model="form.titleTr"></el-input>
                  <span class="error"></span>
                </div>
              </el-col>
              <el-col :span="24" class="mt-3" v-if="form.isCustom == true">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>Url</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>Modülün erişeceği url'i tanımlar.</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                  <el-input v-model="form.url" :class="$inputError('url', validationErrors)">
                    <template slot="prepend">
                      https://
                    </template>
                  </el-input>
                  <span class="error">{{ $errorMessage('url', validationErrors) }}</span>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </transition>

        <el-col :span="24" class="mt-3" v-if="form.isCustom == true">
          <div class="registerform-input-container">
            <div class="custom-label">
              <label>{{$t('components.eventinfo.pageModuleUpdate.content')}}</label>
              <el-tooltip placement="top">
                <div slot="content" class="custom-tooltip-content">
                  <span>{{$t('components.eventinfo.pageModuleUpdate.contentMsg')}}</span>
                </div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
            <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-model="form.details" />
            <span class="error">{{ $errorMessage('details', validationErrors) }}</span>
          </div>
        </el-col>

        <el-col class="mt-2" :span="24">
          <div class="custom-section-container">
            <div class="section-header" @click="settingsDock = !settingsDock">
              <div class="section-title">
                <div class="section-head">
                  <label>{{$t('components.eventinfo.pageModuleUpdate.settings')}}</label>
                  <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                </div>
                <span>{{$t('components.eventinfo.pageModuleUpdate.settingsMsg')}}</span>
              </div>
              <div class="section-accordion">
                <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
              </div>
            </div>
            <transition name="el-zoom-in-top">
              <div class="section-wrapper" v-show="settingsDock">
                <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                  <div class="custom-set-inner">
                    <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                    <div class="custom-set-info">
                      <label>{{$t('components.eventinfo.pageModuleUpdate.show')}}
                        <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                      </label>
                      <span>{{$t('components.eventinfo.pageModuleUpdate.showMsg')}}</span>
                    </div>
                  </div>
                  <div class="custom-set-actions fend">
                    <el-switch v-model="form.isActive"></el-switch>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </el-col>

    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog');">{{$t('components.eventinfo.pageModuleUpdate.close')}}</el-button>
        <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash" @click="deleteItem"> {{$t('components.eventinfo.pageModuleUpdate.delete')}}</el-button>
        </el-popconfirm>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="updated">{{$t('components.eventinfo.pageModuleUpdate.save')}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';
  import axios from 'axios';
  export default {
    props: ['data'],
    components: {
      quillEditor,
    },
    data() {
      return {
        axios,
        settingsDock: false,
        validationErrors: [],
        form: this.data,
        type: 0,
        editorOption: {
          modules: {
            toolbar: [['bold', 'italic', 'underline', 'strike'], [{ color: [] }, { background: [] }], ['clean'], ['link', 'image']],
            syntax: {
              highlight: (text) => hljs.highlightAuto(text).value,
            },
          },
        },
      };
    },
    methods: {
      deleteItem() {
        this.$emit('deleteMe');
        this.$emit('closeMe');
      },
      updated() {
        this.$emit('updated', this.form);
      },
      onEditorReady(editor) {
        editor.root.setAttribute('data-placeholder', this.$t('enterText'));
        editor.getModule('toolbar').addHandler('image', () => {
          this.selectLocalImage(editor);
        });
      },
      selectLocalImage(editor) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.click();
        input.onchange = () => {
          const file = input.files[0];
          if (/^image\//.test(file.type)) {
            this.saveToServer(file, editor);
            this.quillUploading = 'Image upload process started.';
          } else {
            //console.warn("You could only upload images.");
            this.quillUploading = 'You could only upload images.';
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        };
      },
      saveToServer(file, editor) {
        const fd = new FormData();

        fd.append('image', file);
        const xhr = new XMLHttpRequest();
        xhr.open('POST', axios.defaults.baseURL + 'event/uploadImage?uploadType=html&language=' + this.$i18n.locale, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));

        xhr.onload = () => {
          if (xhr.status === 200) {
            const body = JSON.parse(xhr.responseText);
            if (body.alert.hasError == false) {
              const url = body.data.item.url;
              this.insertToEditor(url, editor);
              this.quillUploading = 'Image upload process completed successfully.';
              setTimeout(() => {
                this.quillUploading = false;
              }, 3000);
            } else {
              this.$message.error(body.alert.message);
              this.quillUploading = body.alert.message;
              setTimeout(() => {
                this.quillUploading = false;
              }, 3000);
            }
          } else {
            this.quillUploading = xhr.statusText + ' (Code: ' + xhr.status + ')';
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        };

        xhr.send(fd);
      },
      insertToEditor(url, editor) {
        editor.insertEmbed(editor.getSelection().index, 'image', url);
      },
    },
  };
</script>

<style lang="less" scoped>
  .event-info-page-module-update {
    padding: 1rem;
  }
  .registerform-input-container {
    .el-upload {
      width: 100% !important;
    }
    .tag-container {
      gap: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .badge-list {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      .badger {
        border-radius: 8px;
        background-color: #f3f3f3;
        height: 20px;
        padding: 10px;
      }
    }
    .title {
      i {
        cursor: pointer;
      }
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5rem;
      gap: 0.3rem;
      label {
        font-weight: bold;
        color: black;
        margin-bottom: 0;
      }
      .title-container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
      }
    }
    display: flex;
    flex-direction: column;
    .el-input-number {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/eventinfo/PageModuleUpdate.vue